export interface ShoppingProduct {
  id: number;
  name: string;
  price: number;
  originalPrice: number;
  discount: number;
  image: string;
  category: string;
  subCategory: string;
  link: string;
}

export interface ShoppingCategoryConfig {
  title: string;
  subtitle: string;
  description: string;
  heroBg: string;
  accentColor: string;
  heroImage: string;
  filters: string[];
  products: ShoppingProduct[];
}

export const shoppingData: Record<string, ShoppingCategoryConfig> = {
  femme: {
    title: 'Shopping Femme',
    subtitle: 'Mode, élégance & tendances',
    description: 'Découvrez une sélection raffinée de pièces intemporelles et tendances pour sublimer votre style au quotidien.',
    heroBg: 'from-rose-100 via-pink-50 to-white',
    accentColor: 'pink',
    heroImage: '/femme-hero.jpg',
    filters: ['Tout', 'Robes', 'Tops', 'Pantalons', 'Accessoires', 'Chaussures', 'Sacs'],
    products: [
      {
        id: 101,
        name: 'Robe midi fluide à imprimé floral',
        price: 42.99,
        originalPrice: 68.00,
        discount: 37,
        image: 'https://readdy.ai/api/search-image?query=elegant%20midi%20floral%20printed%20dress%20on%20clean%20white%20background%2C%20fashion%20product%20photography%2C%20soft%20natural%20lighting%2C%20feminine%20style%2C%20professional%20product%20shot&width=400&height=500&seq=f1&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Robes',
        link: 'https://fr.aliexpress.com/item/1005001000001.html',
      },
      {
        id: 102,
        name: 'Blazer oversize camel premium',
        price: 64.99,
        originalPrice: 99.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=oversized%20camel%20blazer%20jacket%20product%20photography%20on%20white%20background%2C%20womens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f2&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Tops',
        link: 'https://fr.aliexpress.com/item/1005001000002.html',
      },
      {
        id: 103,
        name: 'Pantalon wide leg taille haute',
        price: 38.99,
        originalPrice: 59.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=wide%20leg%20high%20waist%20trousers%20product%20photography%20on%20white%20background%2C%20womens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f3&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Pantalons',
        link: 'https://fr.aliexpress.com/item/1005001000003.html',
      },
      {
        id: 104,
        name: 'Sac cabas cuir vachette naturelle',
        price: 89.99,
        originalPrice: 145.00,
        discount: 38,
        image: 'https://readdy.ai/api/search-image?query=natural%20leather%20tote%20bag%20product%20photography%20on%20white%20background%2C%20womens%20luxury%20handbag%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f4&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Sacs',
        link: 'https://fr.aliexpress.com/item/1005001000004.html',
      },
      {
        id: 105,
        name: 'Mules à talons carrés nude',
        price: 36.99,
        originalPrice: 55.00,
        discount: 33,
        image: 'https://readdy.ai/api/search-image?query=nude%20block%20heel%20mules%20shoes%20product%20photography%20on%20white%20background%2C%20womens%20fashion%20footwear%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f5&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Chaussures',
        link: 'https://fr.aliexpress.com/item/1005001000005.html',
      },
      {
        id: 106,
        name: 'Ensemble co-ord lin naturel',
        price: 54.99,
        originalPrice: 84.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=linen%20co-ord%20matching%20set%20blouse%20and%20trousers%20product%20photography%20on%20white%20background%2C%20womens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f6&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Tops',
        link: 'https://fr.aliexpress.com/item/1005001000006.html',
      },
      {
        id: 107,
        name: 'Collier doré minimaliste chaîne',
        price: 18.99,
        originalPrice: 29.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=minimalist%20gold%20chain%20necklace%20jewelry%20product%20photography%20on%20white%20background%2C%20womens%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f7&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005001000007.html',
      },
      {
        id: 108,
        name: 'Robe courte broderie anglaise',
        price: 47.99,
        originalPrice: 72.00,
        discount: 33,
        image: 'https://readdy.ai/api/search-image?query=white%20eyelet%20embroidery%20short%20dress%20product%20photography%20on%20white%20background%2C%20womens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=f8&orientation=portrait',
        category: 'Shopping Femme',
        subCategory: 'Robes',
        link: 'https://fr.aliexpress.com/item/1005001000008.html',
      },
    ],
  },

  homme: {
    title: 'Shopping Homme',
    subtitle: 'Style, élégance & modernité',
    description: 'Une sélection soigneuse de pièces modernes et intemporelles pour un style masculin affirmé et raffiné.',
    heroBg: 'from-slate-100 via-gray-50 to-white',
    accentColor: 'gray',
    heroImage: '/homme-hero.jpg',
    filters: ['Tout', 'Chemises', 'T-shirts', 'Pantalons', 'Vestes', 'Chaussures', 'Accessoires'],
    products: [
      {
        id: 201,
        name: 'Chemise oxford slim-fit blanc cassé',
        price: 39.99,
        originalPrice: 62.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=slim%20fit%20oxford%20shirt%20off-white%20product%20photography%20on%20white%20background%2C%20mens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h1&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'Chemises',
        link: 'https://fr.aliexpress.com/item/1005002000001.html',
      },
      {
        id: 202,
        name: 'T-shirt oversize coton biologique',
        price: 24.99,
        originalPrice: 38.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=oversized%20organic%20cotton%20t-shirt%20product%20photography%20on%20white%20background%2C%20mens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h2&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'T-shirts',
        link: 'https://fr.aliexpress.com/item/1005002000002.html',
      },
      {
        id: 203,
        name: 'Chino stretch coupe droite',
        price: 44.99,
        originalPrice: 68.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=straight%20cut%20stretch%20chino%20trousers%20product%20photography%20on%20white%20background%2C%20mens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h3&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'Pantalons',
        link: 'https://fr.aliexpress.com/item/1005002000003.html',
      },
      {
        id: 204,
        name: 'Veste bomber satin réversible',
        price: 74.99,
        originalPrice: 115.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=reversible%20satin%20bomber%20jacket%20product%20photography%20on%20white%20background%2C%20mens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h4&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'Vestes',
        link: 'https://fr.aliexpress.com/item/1005002000004.html',
      },
      {
        id: 205,
        name: 'Sneakers cuir blanc minimaliste',
        price: 59.99,
        originalPrice: 89.00,
        discount: 33,
        image: 'https://readdy.ai/api/search-image?query=white%20leather%20minimalist%20sneakers%20shoes%20product%20photography%20on%20white%20background%2C%20mens%20footwear%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h5&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'Chaussures',
        link: 'https://fr.aliexpress.com/item/1005002000005.html',
      },
      {
        id: 206,
        name: 'Montre analogique cadran noir',
        price: 49.99,
        originalPrice: 78.00,
        discount: 36,
        image: 'https://readdy.ai/api/search-image?query=black%20dial%20analog%20watch%20product%20photography%20on%20white%20background%2C%20mens%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h6&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005002000006.html',
      },
      {
        id: 207,
        name: 'Pull col roulé mérinos doux',
        price: 54.99,
        originalPrice: 84.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=merino%20wool%20turtleneck%20sweater%20product%20photography%20on%20white%20background%2C%20mens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h7&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'T-shirts',
        link: 'https://fr.aliexpress.com/item/1005002000007.html',
      },
      {
        id: 208,
        name: 'Ceinture cuir tressé camel',
        price: 22.99,
        originalPrice: 35.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=braided%20camel%20leather%20belt%20product%20photography%20on%20white%20background%2C%20mens%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=h8&orientation=portrait',
        category: 'Shopping Homme',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005002000008.html',
      },
    ],
  },

  enfant: {
    title: 'Shopping Enfant',
    subtitle: 'Confort, jeu & créativité',
    description: 'Des vêtements colorés, confortables et durables pensés pour le quotidien des petits aventuriers.',
    heroBg: 'from-amber-50 via-orange-50 to-white',
    accentColor: 'orange',
    heroImage: '/enfant-hero.jpg',
    filters: ['Tout', 'Fille', 'Garçon', 'Bébé', 'Pyjamas', 'Chaussures', 'Accessoires'],
    products: [
      {
        id: 301,
        name: 'Ensemble velours fille rose poudré',
        price: 28.99,
        originalPrice: 44.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=powder%20pink%20velvet%20kids%20girl%20outfit%20set%20product%20photography%20on%20white%20background%2C%20childrens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e1&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Fille',
        link: 'https://fr.aliexpress.com/item/1005003000001.html',
      },
      {
        id: 302,
        name: 'Jogging garçon imprimé dinosaures',
        price: 24.99,
        originalPrice: 38.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=dinosaur%20print%20kids%20boy%20jogger%20tracksuit%20product%20photography%20on%20white%20background%2C%20childrens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e2&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Garçon',
        link: 'https://fr.aliexpress.com/item/1005003000002.html',
      },
      {
        id: 303,
        name: 'Pyjama polaire 2 pièces étoiles',
        price: 19.99,
        originalPrice: 31.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=star%20print%20fleece%20kids%20pajama%20set%20product%20photography%20on%20white%20background%2C%20childrens%20sleepwear%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e3&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Pyjamas',
        link: 'https://fr.aliexpress.com/item/1005003000003.html',
      },
      {
        id: 304,
        name: 'Basket montante enfant licorne',
        price: 22.99,
        originalPrice: 35.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=unicorn%20high%20top%20sneaker%20kids%20shoes%20product%20photography%20on%20white%20background%2C%20childrens%20footwear%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e4&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Chaussures',
        link: 'https://fr.aliexpress.com/item/1005003000004.html',
      },
      {
        id: 305,
        name: 'Robe tutu anniversaire bébé',
        price: 17.99,
        originalPrice: 27.00,
        discount: 33,
        image: 'https://readdy.ai/api/search-image?query=birthday%20tutu%20baby%20girl%20dress%20product%20photography%20on%20white%20background%2C%20baby%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e5&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Bébé',
        link: 'https://fr.aliexpress.com/item/1005003000005.html',
      },
      {
        id: 306,
        name: 'Bonnet pompom laine doux hiver',
        price: 12.99,
        originalPrice: 19.00,
        discount: 32,
        image: 'https://readdy.ai/api/search-image?query=soft%20wool%20pompom%20winter%20hat%20kids%20product%20photography%20on%20white%20background%2C%20childrens%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e6&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005003000006.html',
      },
      {
        id: 307,
        name: 'Doudoune légère garçon navy',
        price: 34.99,
        originalPrice: 54.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=navy%20lightweight%20puffer%20jacket%20kids%20boy%20product%20photography%20on%20white%20background%2C%20childrens%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e7&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Garçon',
        link: 'https://fr.aliexpress.com/item/1005003000007.html',
      },
      {
        id: 308,
        name: 'Sac à dos licorne école primaire',
        price: 26.99,
        originalPrice: 41.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=unicorn%20kids%20school%20backpack%20product%20photography%20on%20white%20background%2C%20childrens%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=e8&orientation=portrait',
        category: 'Shopping Enfant',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005003000008.html',
      },
    ],
  },

  unisexe: {
    title: 'Shopping Unisexe',
    subtitle: 'Mode sans genre, style universel',
    description: 'Des pièces intemporelles qui s\'adaptent à tous les styles et toutes les silhouettes, sans distinction.',
    heroBg: 'from-violet-50 via-fuchsia-50 to-white',
    accentColor: 'violet',
    heroImage: '/unisex-hero.jpg',
    filters: ['Tout', 'Sweats', 'T-shirts', 'Pantalons', 'Vestes', 'Chaussures', 'Accessoires'],
    products: [
      {
        id: 401,
        name: 'Hoodie oversize coton premium',
        price: 44.99,
        originalPrice: 69.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=oversized%20premium%20cotton%20hoodie%20sweatshirt%20product%20photography%20on%20white%20background%2C%20unisex%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u1&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'Sweats',
        link: 'https://fr.aliexpress.com/item/1005004000001.html',
      },
      {
        id: 402,
        name: 'T-shirt brodé logo minimaliste',
        price: 26.99,
        originalPrice: 41.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=minimalist%20logo%20embroidered%20t-shirt%20product%20photography%20on%20white%20background%2C%20unisex%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u2&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'T-shirts',
        link: 'https://fr.aliexpress.com/item/1005004000002.html',
      },
      {
        id: 403,
        name: 'Cargo pants multi-poches kaki',
        price: 48.99,
        originalPrice: 75.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=khaki%20cargo%20pants%20multi-pocket%20product%20photography%20on%20white%20background%2C%20unisex%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u3&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'Pantalons',
        link: 'https://fr.aliexpress.com/item/1005004000003.html',
      },
      {
        id: 404,
        name: 'Veste coach imperméable légère',
        price: 62.99,
        originalPrice: 96.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=lightweight%20waterproof%20coach%20jacket%20product%20photography%20on%20white%20background%2C%20unisex%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u4&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'Vestes',
        link: 'https://fr.aliexpress.com/item/1005004000004.html',
      },
      {
        id: 405,
        name: 'Sneakers chunky semelle épaisse',
        price: 66.99,
        originalPrice: 99.00,
        discount: 32,
        image: 'https://readdy.ai/api/search-image?query=chunky%20thick%20sole%20sneakers%20product%20photography%20on%20white%20background%2C%20unisex%20footwear%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u5&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'chaussures',
        link: 'https://fr.aliexpress.com/item/1005004000005.html',
      },
      {
        id: 406,
        name: 'Casquette brodée vintage logo',
        price: 19.99,
        originalPrice: 31.00,
        discount: 36,
        image: 'https://readdy.ai/api/search-image?query=vintage%20logo%20embroidered%20baseball%20cap%20product%20photography%20on%20white%20background%2C%20unisex%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u6&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005004000006.html',
      },
      {
        id: 407,
        name: 'Sweat crewneck lavande doux',
        price: 36.99,
        originalPrice: 56.00,
        discount: 34,
        image: 'https://readdy.ai/api/search-image?query=lavender%20soft%20crewneck%20sweatshirt%20product%20photography%20on%20white%20background%2C%20unisex%20fashion%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u7&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'Sweats',
        link: 'https://fr.aliexpress.com/item/1005004000007.html',
      },
      {
        id: 408,
        name: 'Tote bag canvas sérigraphie',
        price: 14.99,
        originalPrice: 23.00,
        discount: 35,
        image: 'https://readdy.ai/api/search-image?query=canvas%20screen%20printed%20tote%20bag%20product%20photography%20on%20white%20background%2C%20unisex%20accessories%2C%20professional%20product%20shot%2C%20soft%20lighting%2C%20clean%20minimal%20backdrop&width=400&height=500&seq=u8&orientation=portrait',
        category: 'Shopping Unisexe',
        subCategory: 'Accessoires',
        link: 'https://fr.aliexpress.com/item/1005004000008.html',
      },
    ],
  },
};
